import React from 'react';
const tomes = [{
  emoji: '🪣',
  title: 'Tomo 1 — Fundamentos Pro (La Base que Nadie te Enseñó)',
  desc: 'Por qué el 90% de los lavados arruinan la pintura. El sistema de 3 baldes, clay bar, descontaminación y protocolo de secado sin rayas desde el día uno.'
}, {
  emoji: '💿',
  title: 'Tomo 2 — El Arte del Pulido',
  desc: 'El servicio que más paga. Corrección de pintura en 1, 2 y 3 pasos. Cómo eliminar swirl marks, hologramas y rayas profundas con cualquier presupuesto de herramientas.'
}, {
  emoji: '🪑',
  title: 'Tomo 3 — Interiores Extremos',
  desc: 'Extracción de tapizados, restauración de cueros y plásticos, y eliminación definitiva de olores. El servicio que los clientes pagan sin negociar.'
}, {
  emoji: '⚗️',
  title: 'Tomo 4 — Química y Costos',
  desc: 'Diluciones correctas, costo real por servicio y cómo comprar bien para gastar menos. Nunca más perdas plata por no saber calcular un presupuesto.'
}, {
  emoji: '💰',
  title: 'Tomo 5 — El Negocio Cash',
  desc: 'Cómo conseguir tus primeros clientes sin redes sociales, cómo fijar precios sin miedo y el sistema para tener la agenda llena en los primeros 30 días.'
}, {
  emoji: '🏆',
  title: 'Tomo 6 — Protección y Sellado Cerámico',
  desc: 'Ceras, selladores y cerámicos de 9H. El servicio que cobra entre $150.000 y $400.000 por trabajo y diferencia al amateur del profesional.'
}];
const includes = ['Protocolo de lavado técnico paso a paso sin rayones', 'Checklist de recepción de vehículo como un taller pro', 'Guía de diluciones de productos para no desperdiciar insumos', 'Sistema de fotografía antes y después para vender más', 'Protocolo de corrección de pintura en 3 niveles', 'Tabla de precios y costos por servicio actualizada 2024', 'Plan de captación de clientes de alto ticket en tu ciudad', '100% adaptado a la realidad del detailer argentino'];
export function WhatYouGet() {
  return <section className="w-full px-4 py-10 text-base leading-6" style={{
    backgroundColor: '#0d0d0d',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-307">
      <div className="mx-auto max-w-4xl" data-id="element-308">
        {/* Heading */}
        <h2 className="text-3xl font-black text-center leading-10 text-white m-0 mb-8" data-id="element-309">
          Lo que <span className="text-yellow-400" data-id="element-310">recibís</span>
        </h2>

        {/* 6 Tomos Card */}
        <div className="mx-auto max-w-3xl mb-8" data-id="element-311">
          <div className="bg-white/5 border border-yellow-400/30 rounded-xl p-5 shadow-sm" data-id="element-312">
            <h3 className="text-lg font-black text-yellow-400 m-0 mb-1" data-id="element-313">
              🚗 LOS 6 TOMOS
            </h3>
            <p className="text-xs text-gray-400 m-0 mb-4" data-id="element-314">
              Para principiantes y detailers que quieren profesionalizar su
              técnica y cobrar lo que realmente vale su trabajo
            </p>

            <div className="space-y-3" data-id="element-315">
              {tomes.map(tome => <div key={tome.title} className="flex items-center gap-2 text-white" data-id="element-316">
                  <span className="text-lg" data-id="element-317">{tome.emoji}</span>
                  <div className="flex-1 text-sm" data-id="element-318">
                    <span className="font-bold text-white" data-id="element-319">{tome.title}</span>{' '}
                    <span className="text-gray-400" data-id="element-320">{tome.desc}</span>
                  </div>
                </div>)}
            </div>
          </div>
        </div>

        {/* Each Tome Includes */}
        <div className="mx-auto max-w-3xl bg-yellow-400/5 text-center border border-yellow-400/30 rounded-xl p-6 shadow-sm" data-id="element-321">
          <h3 className="text-lg font-black text-yellow-400 m-0 mb-4" data-id="element-322">
            Cada tomo incluye:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-323">
            {includes.map(item => <div key={item} className="flex items-start gap-2 text-left" data-id="element-324">
                <span className="shrink-0 font-bold text-yellow-400 text-sm" data-id="element-325">
                  ✅
                </span>
                <span className="text-xs text-gray-300" data-id="element-326">{item}</span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}